import React from "react";

type Props = {
    children: React.ReactNode;
};

export const AppShell = ({ children }: Props) => {
    const bg = require("../../assets/img/bg.png");

    return (
        <div
            className="appShell"
            style={{
                //backgroundImage: `linear-gradient(rgba(6,4,12,.88), rgba(6,4,12,.88)), url(${bg})`,
                backgroundImage: `
  linear-gradient(
    rgba(6,4,12,0.55),
    rgba(6,4,12,0.55)
  ),
  url(${bg})`,
            }}
        >
            {children}
        </div>
    );
};
